<section id="page-title" class="page-title-mini">
  <div class="container"></div>
</section>

<div class="section my-0 p-b-0">
  <div class="container">
    <div class="row">
      <div class="m-t-55 col-mb-100 login-sidebar col-7 pr-0">
        <div class="postcontent ma-box-contact-us col-lg-12 m-b-30 p-b-10">
          <div class="dark">
            <div class="info-header">
              <h4 class="info-title">{{ 'Contact Us' | translate }}</h4>
            </div>
            <hr>

            <ng-container *ngIf="!isSkeletonContactList; else skeletonContactList">
              <h5>{{ 'Chat with Us' | translate }}</h5>
              <ul class="contact-us-wrapper list-unstyled">
                <li *ngIf="!isQP20">
                  <a (click)="openLiveChat()">
                    <span [innerHTML]="svg.liveChatIcon | safeHtml"></span>
                    <p class="contact-icon-text">{{ 'Live Chat' | translate }}</p>
                  </a>
                </li>
                <ng-container *ngFor="let item of contactList">
                  <li *ngIf="item.contact_type === 'Support'">
                    <a (click)="onContact(item.locales[0].link)">
                      <span [innerHTML]="svg[(item.image_icon.replace('.png', '') + 'Icon')] | safeHtml"></span>
                      <p class="contact-icon-text">{{ item.locales[0].value | uppercase }}</p>
                    </a>
                  </li>
                </ng-container>
              </ul>

              <div class="m-t-40" *ngIf="hasType('Social')">
                <h5>{{ 'Follow Us' | translate }}</h5>
                <ul class="contact-us-wrapper list-unstyled">
                  <ng-container *ngFor="let item of contactList">
                    <li *ngIf="item.contact_type === 'Social'">
                      <a (click)="onContact(item.locales[0].link)">
                        <span [innerHTML]="svg[(item.image_icon.replace('.png', '') + 'Icon')] | safeHtml"></span>
                        <p class="contact-icon-text">{{ item.locales[0].value | uppercase }}</p>
                      </a>
                    </li>
                  </ng-container>
                </ul>
              </div>
            </ng-container>

            <ng-template #skeletonContactList>
              <h5>
                <p class="skeleton skeleton-heading"></p>
              </h5>
              <ul class="contact-us-wrapper list-unstyled">
                <ng-container *ngFor="let item of [].constructor(4)">
                  <li>
                    <a>
                      <span class="skeleton skeleton-contact-icon"></span>
                      <p class="skeleton skeleton-text contact-icon-text"></p>
                    </a>
                  </li>
                </ng-container>
              </ul>
              <div class="m-t-40">
                <h5>
                  <p class="skeleton skeleton-heading"></p>
                </h5>
                <ul class="contact-us-wrapper list-unstyled">
                  <ng-container *ngFor="let item of [].constructor(2)">
                    <li>
                      <a>
                        <span class="skeleton skeleton-contact-icon"></span>
                        <p class="skeleton skeleton-text contact-icon-text"></p>
                      </a>
                    </li>
                  </ng-container>
                </ul>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="m-t-55 col-5 content-info-img"></div>
    </div>
  </div>
</div>
